export const iconFontAwesomeUsersPeoplePersonSnowboarding = (
	<i className="fa-solid fa-person-snowboarding"></i>
);
